export const Translations = {
  en: {
    'Enter names below': 'Enter names below',
    Shuffle: 'Shuffle',
    Start: 'Start',
    General: 'General',
    Fairness: 'Fairness',
    Branding: 'Branding',
    'Branding & Sponsors': 'Branding & Sponsors',
    Map: 'Map',
    'Render quality': 'Render quality',
    Performance: 'Performance',
    Native: 'Native',
    Recording: 'Recording',
    'The winner is': 'The winner is',
    'Using skills': 'Using skills',
    First: 'First',
    Last: 'Last',
    Multiple: 'Multiple',
    'Wheel of fortune': 'Wheel of fortune',
    BubblePop: 'BubblePop',
    'Pot of greed': 'Pot of greed',
    'Yoru ni Kakeru': 'Into The Night (by item4)',
    'Shake!': 'Shake!',
    'Input names separated by commas or line feed here': 'Input names separated by commas or line feed here',
    'This program is freeware and may be used freely anywhere, including in broadcasts and videos.':
      'This program is freeware and may be used freely anywhere, including in broadcasts and videos.',
    Close: 'Close',
    'The result has been copied': 'The result has been copied',
    'Cumulative fairness': 'Cumulative fairness',
    Enabled: 'Enabled',
    Simple: 'Simple',
    Complete: 'Complete',
    'Start a new fairness period': 'Start a new fairness period',
    Export: 'Export',
    Import: 'Import',
    'Delete history': 'Delete history',
    Mode: 'Mode',
    Excluded: 'Excluded',
    Rename: 'Rename',
    Void: 'Void',
    Asset: 'Asset',
    Sponsor: 'Sponsor',
    Participant: 'Participant',
    Wins: 'Wins',
    Action: 'Action',
    Actual: 'Actual',
    Credit: 'Credit',
    Effective: 'Effective',
    Time: 'Time',
    Winner: 'Winner',
    Status: 'Status',
    Seed: 'Seed',
    Details: 'Details',
    Participants: 'Participants',
    History: 'History',
  },
  ko: {
    'Enter names below': '이름들을 입력하세요',
    Shuffle: '섞기',
    Start: '시작',
    General: '일반',
    Fairness: '누적 균등',
    Branding: '브랜딩',
    'Branding & Sponsors': '브랜딩 및 스폰서',
    Map: '맵',
    'Render quality': '렌더링 품질',
    Performance: '성능 우선',
    Native: '기본',
    Recording: '녹화',
    'The winner is': '당첨 순위',
    'Using skills': '스킬 활성화',
    First: '첫번째',
    Last: '마지막',
    Multiple: '여러명',
    'Wheel of fortune': '운명의 수레바퀴',
    BubblePop: '버블팝',
    'Pot of greed': '욕망의 항아리',
    'Yoru ni Kakeru': '밤을 달리다 (by item4)',
    'Shake!': '흔들기!',
    'Input names separated by commas or line feed here': '이름들을 쉼표나 엔터로 구분해서 넣어주세요',
    'This program is freeware and may be used freely anywhere, including in broadcasts and videos.':
      '이 프로그램은 프리웨어이며 방송이나 영상 등을 포함한 어떤 용도로든 자유롭게 사용하는 것이 허용되어있습니다.',
    Close: '닫기',
    'The result has been copied': '결과가 복사되었습니다',
    'Cumulative fairness': '누적 균등',
    Enabled: '활성화',
    Simple: '간단히',
    Complete: '상세히',
    'Start a new fairness period': '새 균등화 시작',
    Export: '내보내기',
    Import: '가져오기',
    'Delete history': '기록 삭제',
    Mode: '모드',
    Excluded: '제외',
    Rename: '이름 변경',
    Void: '무효화',
    Asset: '에셋',
    Sponsor: '스폰서',
    Participant: '참가자',
    Wins: '승리 횟수',
    Action: '동작',
    Actual: '실제',
    Credit: '크레딧',
    Effective: '유효',
    Time: '시간',
    Winner: '당첨자',
    Status: '상태',
    Seed: '시드',
    Details: '상세 정보',
    Participants: '참가자',
    History: '추첨 기록',
  },
} as const;

export type TranslatedLanguages = keyof typeof Translations;

export type TranslationKeys = keyof (typeof Translations)[TranslatedLanguages];
